import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, SvgIcon, Tooltip } from '@material-ui/core';
import styles from './PinAction.module.scss';

export const PushPinIcon = ({ pinned = false }) => (
  <SvgIcon
    aria-hidden="true"
    className={`${styles.icon} ${pinned ? styles.iconPinned : ''}`.trim()}
  >
    <path d="M16 9V4h1V2H7v2h1v5c0 1.1-.9 2-2 2v2h5.2v7h1.6v-7H18v-2c-1.1 0-2-.9-2-2z" />
  </SvgIcon>
);

PushPinIcon.propTypes = { pinned: PropTypes.bool };

PushPinIcon.defaultProps = { pinned: false };

const PinAction = ({ pinned, label, onClick, revealOnHover, className }) => (
  <Tooltip title={label}>
    <IconButton
      size="small"
      className={`${styles.button} ${pinned ? styles.pinned : ''} ${revealOnHover && !pinned ? styles.revealOnHover : ''} ${className}`.trim()}
      aria-label={label}
      aria-pressed={pinned}
      onClick={onClick}
    >
      <PushPinIcon pinned={pinned} />
    </IconButton>
  </Tooltip>
);

PinAction.propTypes = {
  pinned: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  revealOnHover: PropTypes.bool,
  className: PropTypes.string,
};

PinAction.defaultProps = { revealOnHover: true, className: '' };

export default PinAction;
